import { render, staticRenderFns } from "./AnnouncementHeader.vue?vue&type=template&id=1e668648&scoped=true&"
import script from "./AnnouncementHeader.vue?vue&type=script&lang=js&"
export * from "./AnnouncementHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e668648",
  null
  
)

export default component.exports